import React from 'react';
import { Button } from 'react-bootstrap';
import { onLoggedOut } from '../../../state/user/userSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useDeleteAccountMutation } from '../../../services/myFlixApi';
import { toast } from 'react-toastify';

export const RemoveAccountLink = () => {
  const { user } = useSelector((state) => state.user);

  const [deleteAccount] = useDeleteAccountMutation();

  const dispatch = useDispatch();

  const handleDeleteAccount = async (event) => {
    event.preventDefault();
    try {
      const response = await deleteAccount(user.Email);

      if (response?.data?.success) {
        dispatch(onLoggedOut());
      } else {
        toast.error(response.error.data.error.message);
      }
    } catch (error) {
      toast.error('Something went wrong!');
      console.log(error);
    }
  };

  return (
    <Button onClick={handleDeleteAccount} variant="link" type="submit" className="text-danger p-0 mt-3">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-trash"
        viewBox="0 0 16 16"
      >
        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
      </svg>
      <small className="ms-2">Remove account permanently</small>
    </Button>
  );
};
